import { ElementRef, EventEmitter, QueryList } from '@angular/core';
import { NgModel } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
var DEFAULT_MAX_LENGTH = 2000;
var AchooInputComponent = /** @class */ (function () {
    function AchooInputComponent(validationHandlerService) {
        this.validationHandlerService = validationHandlerService;
        this.modelChange = new EventEmitter();
        this.keyDownEvent = new EventEmitter();
        this.keyUpEvent = new EventEmitter();
        this.enterEvent = new EventEmitter();
        this.focusEvent = new EventEmitter();
        this.focusOutEvent = new EventEmitter();
        this.required = false;
        this.validationErrorsSubjectSubscription = Observable.combineLatest(this.validationHandlerService.validationErrorsSubject, this.validationHandlerService.validationDisplaySubject).subscribe(this.refreshErrors.bind(this));
    }
    Object.defineProperty(AchooInputComponent.prototype, "model", {
        get: function () {
            return this.model_;
        },
        set: function (value) {
            this.onModelChange(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AchooInputComponent.prototype, "errors", {
        get: function () {
            return this._errors;
        },
        enumerable: true,
        configurable: true
    });
    AchooInputComponent.prototype.onModelChange = function (value) {
        this._errors = [];
        this.modelChange.emit(value);
        this.model_ = value;
    };
    AchooInputComponent.prototype.ngOnInit = function () {
    };
    AchooInputComponent.prototype.ngOnDestroy = function () {
        if (this.validationErrorsSubjectSubscription) {
            this.validationErrorsSubjectSubscription.unsubscribe();
        }
    };
    AchooInputComponent.prototype.getMaxLength = function () {
        return this.maxlength || DEFAULT_MAX_LENGTH;
    };
    AchooInputComponent.prototype.onKeyDown = function (key) {
        this.keyDownEvent.emit(key);
    };
    AchooInputComponent.prototype.onKeyUp = function (event) {
        this.keyUpEvent.emit(event);
    };
    AchooInputComponent.prototype.onEnter = function (event) {
        event.stopPropagation();
        event.preventDefault();
        this.enterEvent.emit(event.target);
    };
    AchooInputComponent.prototype.onFocus = function (event) {
        this.focusEvent.emit(event);
    };
    AchooInputComponent.prototype.onFocusOut = function (event) {
        this.focusOutEvent.emit(event);
    };
    AchooInputComponent.prototype.buildChildId = function () {
        return (this.id || this.name) + '_Child';
    };
    AchooInputComponent.prototype.setFocus = function () {
        if (this._entryElement) {
            this._entryElement.nativeElement.focus();
        }
    };
    AchooInputComponent.prototype.refreshErrors = function (results) {
        var _this = this;
        var errors = results[0];
        var shouldDisplayErrors = results[1];
        if (shouldDisplayErrors) {
            this._errors = errors.filter(function (e) { return e.name === _this.name; });
        }
    };
    AchooInputComponent.prototype.hasErrors = function () {
        return this._errors &&
            this._errors.length > 0;
    };
    AchooInputComponent.prototype.hasError = function () {
        var _this = this;
        return this._errors &&
            this._errors.findIndex(function (err) { return err.name === _this.name; }) >= 0;
    };
    AchooInputComponent.prototype.isTouched = function () {
        return this.inputModelList.filter(function (m) { return !m.touched; }).length === 0;
    };
    return AchooInputComponent;
}());
export { AchooInputComponent };



// WEBPACK FOOTER //
// ./src/app/core/achoo-input/achoo-input.component.ts.pre-build-optimizer.js